import { Link } from "@inertiajs/react"
import { Eye, Settings, UserCheck, Users, ChevronRight } from "lucide-react"

// D7 — the Account quick links. Public profile (AT-01, the eye glyph) leads,
// then Settings / Access / Team. Icons are keyed off the link's `key` so the
// presenter stays icon-free.
const ICONS = {
  PublicProfile: Eye,
  Settings,
  Access: UserCheck,
  Team: Users,
}

export default function QuickLinks({ links = [] }) {
  return (
    <div className="overflow-hidden rounded-2xl border border-border bg-card">
      <div className="border-b border-border px-[22px] py-4">
        <h3 className="font-display text-[14.5px] font-bold">Account</h3>
      </div>

      {links.map((link) => {
        const Icon = ICONS[link.key] ?? ChevronRight
        return (
          <Link
            key={link.key}
            href={link.href}
            className="flex items-center gap-3 border-b border-border px-[22px] py-[13px] no-underline transition-colors last:border-b-0 hover:bg-secondary"
          >
            <span className="grid size-[34px] shrink-0 place-items-center rounded-[9px] border border-border bg-secondary">
              <Icon className="size-[17px] text-muted-foreground" strokeWidth={1.9} />
            </span>
            <span className="min-w-0 flex-1">
              <span className="block text-[13.5px] font-semibold text-foreground">{link.label}</span>
              {link.sub && <span className="block text-xs text-ink-3">{link.sub}</span>}
            </span>
            <ChevronRight className="size-4 shrink-0 text-ink-3" strokeWidth={2} />
          </Link>
        )
      })}
    </div>
  )
}
